import React from 'react';
import Icon from '../../../components/AppIcon';

const StatCard = ({ title, value, change, icon, color = 'primary' }) => {
  const formatAmount = (amount) => {
    if (typeof amount === 'number') {
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })?.format(amount);
    }
    return amount;
  };

  const getColorClasses = () => {
    switch (color) {
      case 'success':
        return 'bg-success/10 text-success';
      case 'warning':
        return 'bg-warning/10 text-warning';
      case 'error':
        return 'bg-error/10 text-error';
      case 'accent':
        return 'bg-accent/10 text-accent';
      default:
        return 'bg-primary/10 text-primary';
    }
  };

  const getColorVar = () => {
    switch (color) {
      case 'success':
        return 'var(--color-success)';
      case 'warning':
        return 'var(--color-warning)';
      case 'error':
        return 'var(--color-error)';
      case 'accent':
        return 'var(--color-accent)';
      default:
        return 'var(--color-primary)';
    }
  };

  return (
    <div className="p-6 bg-card border border-border rounded-lg hover:shadow-elevation-1 transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${getColorClasses()}`}>
          <Icon name={icon} size={24} color={getColorVar()} />
        </div>
        {change !== undefined && (
          <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
            change >= 0 ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
          }`}>
            <Icon name={change >= 0 ? 'TrendingUp' : 'TrendingDown'} size={12} />
            <span>{Math.abs(change)}%</span>
          </div>
        )}
      </div>
      <h3 className="text-sm text-muted-foreground mb-1">{title}</h3>
      <p className="text-2xl font-bold text-foreground">{formatAmount(value)}</p>
    </div>
  );
};

export default StatCard;